import { mapCollection, sortByNumber, sortByNumberReverse } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { SchedulerTaskManufacturingOrder } from '../scheduler-task-manufacturing-order';
import { ManufacturingOrderBuilder } from './manufacturing-order.builder';
import { SchedulerTaskBuilder } from './scheduler-task.builder';

export class SchedulerTaskManufacturingOrderBuilder {

  static fromJson(json) {
    return (json)
      ? new SchedulerTaskManufacturingOrder(
          ManufacturingOrderBuilder.fromJson(json.manufacturingOrder),
          SchedulerTaskBuilder.fromJson(json.schedulerTask),
          parseNumber(json.total),
      )
      : null;
  }

  static fromList(list) {
    return sortByNumber('startDate', mapCollection(SchedulerTaskManufacturingOrderBuilder.fromJson, list));
  }

  static fromListReverse(list) {
    return sortByNumberReverse('startDate', mapCollection(SchedulerTaskManufacturingOrderBuilder.fromJson, list));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/scheduler-task-manufacturing-order.builder.ts